module.exports = __webpack_public_path__ + "static/media/vfl-mobileWithLogo2.2e3b4166.png";